import { useEffect, useRef } from "react";

export default function ParticlesBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    let particles = [];
    const particleCount = 20;
    const mouse = { x: null, y: null };

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    window.addEventListener("mousemove", (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    });

    class Particle {
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.size = Math.random() * 3 + 1;
        this.speedX = Math.random() * 2 - 1;
        this.speedY = Math.random() * 2 - 1;
        this.opacity = 25;
      }
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        this.opacity -= 0.02;
      }
      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(180,180,180,${this.opacity})`;
        ctx.fill();
      }
    }

    function animate() {
      // Optimization: Only redraw if there are particles or mouse interaction
      if (particles.length > 0 || (mouse.x && mouse.y)) {
        ctx.fillStyle = "rgba(0, 0, 0, 0.1)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        if (mouse.x && mouse.y) {
          particles.push(new Particle(mouse.x, mouse.y));
          if (particles.length > particleCount) {
            particles.shift();
          }
        }

        particles.forEach((p, index) => {
          p.update();
          p.draw();
          // Remove invisible particles
          if (p.opacity <= 0) {
            particles.splice(index, 1);
          }
        });
      } else {
        // Clear canvas when idle to prevent trails persisting forever if stopped
        // OR just let it sit. Optimally we clear once when empty.
        if (particles.length === 0) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }

      requestAnimationFrame(animate);
    }
    animate();

    return () => {
      window.removeEventListener("resize", resizeCanvas);
      window.removeEventListener("mousemove", () => { });
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 -z-10 pointer-events-none"
      style={{ background: "#000", width: "100%", height: "100%" }}
    />
  );
}
